import React from 'react';

import PrivacyChangeSummary from '../components/PrivacyChangeSummary';
import BannerAd from '../components/ibok-core/module/BannerAd';
import { responseHandler } from '../utils/api/apiHelper';
import { findActiveBanners } from '../utils/api/bannerApi';

export const myPageId = 'myPageWrapper';

const fetchProfile = () => fetch(
  '/api/v1/users/me',
  {
    credentials: 'same-origin',
  },
).then(responseHandler);

const fetchBanners = () => findActiveBanners('my_page');

const MyPage = () => {
  const [profile, setProfile] = React.useState(null);
  const [banners, setBanners] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    fetchProfile()
      .then(setProfile)
      .catch((err) => {
        console.error('Failed to fetch profile', err);
        setError(err);
      })
      .then(() => setIsLoading(false));

    fetchBanners().then((activeBanners) => {
      setBanners(activeBanners || {});
    });
  }, []);

  if (isLoading) {
    return <div className="main-content">
      <h1>Min side</h1>
      <p>Laster profilen din...</p>
    </div>;
  }

  if (error || !profile) {
    return <div className="main-content">
      <h1>Min side</h1>
      <p>Kunne ikke hente profilen din. Prøv å laste siden på nytt.</p>
    </div>;
  }

  return <div className="main-content">
    <h1>Min side</h1>

    <div>
      <div className="horizontal">
        <div>
          <section className="object person stretch">
            <h2>{profile.name}</h2>
            <ul className="vertical">
              <li><strong>E-postadresse:</strong><span>{profile.email}</span></li>
              <li><strong>Telefon:</strong><span>{profile.phone || 'Ikke oppgitt'}</span></li>
              <li><strong>Aktive annonser:</strong><span className="focus">{profile.activeClassifiedsCount}</span></li>
              {profile.hasVipps && <li><strong>Du støtter betaling med:</strong>
                <span><a href="/hjelp/#vipps" className="icon vipps nohover uncentered"
                  title="Du støtter betaling i vipps"> </a></span>
              </li>}
            </ul>
          </section>
        </div>

        <nav className="vertical user-actions">
          <a className="button dangerous" href="logg_ut" data-browser-auth-logout>Logg ut</a>
          <a className="button" href="mine_annonser">Mine annonser</a>
          {profile.canChangePassword !== false && <a className="button" href="endre_passord">Endre passord</a>}
          <a className="button notification" href="bokvarslinger">Bokvarslinger</a>
          <a className="button" href="innstillinger">Innstillinger</a>
        </nav>
      </div>

      <BannerAd banners={banners} page="my_page" size="desktop"/>
    </div>

    <PrivacyChangeSummary/>
  </div>;
};

export default MyPage;
